import { Lookup } from "../../common/Lookup";

export class CitesExporterDetails{
    exporterName?: string;
    // exporterEmail?: string;
    // exporterPOBox?: string;
    // exporterPhone?: string;
    // exporterFax?: string;
    exporterCountry?: Lookup;
    // exporterCityName?: string;
    exporterAddress?: string;
}